module.exports = __webpack_public_path__ + "static/media/rapunzel-icon.40d4ee02.png";